"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalMonthlyGuildMemberToJSON = exports.GlobalMonthlyGuildMemberFromJSONTyped = exports.GlobalMonthlyGuildMemberFromJSON = void 0;
var runtime_1 = require("../runtime");
function GlobalMonthlyGuildMemberFromJSON(json) {
    return GlobalMonthlyGuildMemberFromJSONTyped(json, false);
}
exports.GlobalMonthlyGuildMemberFromJSON = GlobalMonthlyGuildMemberFromJSON;
function GlobalMonthlyGuildMemberFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'guildIcon': !(0, runtime_1.exists)(json, 'guildIcon') ? undefined : json['guildIcon'],
        'guildName': json['guildName'],
        'totalPoints': json['totalPoints'],
        'nickname': json['nickname'],
        'profilePicture': !(0, runtime_1.exists)(json, 'profilePicture') ? undefined : json['profilePicture'],
        'rank': json['rank'],
        'id': json['id'],
    };
}
exports.GlobalMonthlyGuildMemberFromJSONTyped = GlobalMonthlyGuildMemberFromJSONTyped;
function GlobalMonthlyGuildMemberToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'guildIcon': value.guildIcon,
        'guildName': value.guildName,
        'totalPoints': value.totalPoints,
        'nickname': value.nickname,
        'profilePicture': value.profilePicture,
        'rank': value.rank,
        'id': value.id,
    };
}
exports.GlobalMonthlyGuildMemberToJSON = GlobalMonthlyGuildMemberToJSON;
